import Navbar from "../components/layout/Navbar";
import emailjs from "@emailjs/browser";
import { useRef, useState } from "react";
// @ts-ignore
import jan_farup from "../images/jan_farup.jpg";
// @ts-ignore
import peter from "../images/Peter_AJ.png";

export default function Kontakt() {
    // @ts-ignore
    const form : any = useRef();
    const [emailSent, setEmailSent] = useState(false);
    const loginURL = "https://localhost:7170/Login";
    async function sendDataSimple(){
        try {
            const type = "simple";
            let data = JSON.stringify({
                    username: "hello",
                    password: "world"
                }
            );
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: data
            };
            const response = await fetch(loginURL, options);
            console.log(response.json());
        }
        catch (e) {

        }
        return null;
    }

    const sendEmail = (e : any) => {
        e.preventDefault();

        emailjs
            .sendForm('service_97m9q8f', 'template_fou2amo', form.current, {
                publicKey: 'mFEHUirfnIzJ8aHe5', //mFEHUirfnIzJ8aHe5
            })
            .then(
                () => {
                    console.log('SUCCESS!');
                    setEmailSent(true);
                },
                (error) => {
                    console.log('FAILED...', error.text);
                    setEmailSent(false);
                },
            );
    };

    const contacts = [
        {
            id: 1,
            name: 'Peter Dalsgaard',
            job: "Indehaver & Pensionsmægler",
            Mail: 'peter@propension.dk',
            Telefon: '+45 2390 5602',
            imageUrl: peter,
        },
        {
            id: 2,
            name: 'Jan Farup',
            job: "Partner & Pensionsmægler",
            Mail: 'Jan.farup@propension.dk',
            Telefon: '+45 2465 3609',
            imageUrl: jan_farup,
        }



        // Add more contacts as needed
    ];

    return (
        <>
            <div className="fixed z-20">
                <Navbar/>
            </div>


            <div className="max-w-screen flex justify-center mt-[10em] my-[-8em] relative z-10">
                {contacts.map(contact => (
                    <div key={contact.id} className="card bg-base-100 shadow-lg flex-col mx-10 h-[30em]">
                        <figure>
                            <img src={contact.imageUrl} alt={contact.name}
                                 className="rounded-t-lg object-contain h-[18em] w-[20em]"/>
                        </figure>
                        <div className="card-body">
                            <h2 className="card-title text-lg font-semibold">{contact.name}</h2>
                            <h3 className="card-title text-sm font-semibold">{contact.job}</h3>
                            <br/>
                            <p className="text-sm break-all">Mail: {contact.Mail}</p>
                            <p className="text-sm">Telefon: {contact.Telefon}</p>
                        </div>
                    </div>
                ))}
            </div>


            <br/>
            <div className="bg-white font-textbitter flex justify-center items-center bg-white relative my-[10em]">
                <div className="container mx-auto my-4 px-4 lg:px-20">
                    <form ref={form} onSubmit={sendEmail}>
                        <div
                            className="w-full p-8 my-4 md:px-12 lg:w-9/12 lg:pl-20 lg:pr-40 mr-auto rounded-2xl shadow-2xl">
                            <div className="flex">
                                <h1 className="text-5xl">Kontakt os</h1>
                            </div>
                            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-5">
                                <input
                                    name="from_name"
                                    className="w-full bg-gray-100 z-10 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                    type="text"
                                    placeholder="Fornavn*"
                                    required
                                />
                                <input
                                    name="email"
                                    className="w-full bg-gray-100 z-10 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                    type="email"
                                    placeholder="Email*"
                                    required
                                />
                                <input
                                    name="phone"
                                    className="w-full bg-gray-100 z-10 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                    type="tel"
                                    placeholder="Telefon-nummer*"
                                    required
                                />
                            </div>
                            <div className="my-4">
<textarea
    name="message"
    placeholder="Har du en besked til os?"
    className="w-full h-32 bg-gray-100 z-50 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
    required
/>
                            </div>
                            <div className="my-2 w-1/2 lg:w-1/4">
                                <button
                                    type="submit"
                                    className="text-sm z-[100] bg-[#34842b] text-gray-100 p-3 rounded-lg w-full focus:outline-none focus:shadow-outline"
                                >
                                    Send
                                </button>
                                {emailSent && (
                                    <p className="left text-green-600 text-m">
                                        Din besked er modtaget! Vi vender tilbage hurtigst muligt.
                                    </p>
                                )}
                            </div>
                        </div>
                    </form>

                    <div className="w-full lg:-mt-96 lg:w-2/6 px-8 py-12 ml-auto bg-[#34842b] rounded-3xl">
                        <label className="swap swap-flip">
                            <div className="flex flex-col text-white swap-on">
                            <h1 className="font-bold uppercase text-4xl my-4">Drop in our office</h1>
                                <div className="flex my-4 w-2/3 lg:w-1/2">
                                    <div className="flex flex-col">
                                        <i className="fas fa-map-marker-alt pt-2 pr-2"/>
                                    </div>
                                    <div className="flex flex-col">
                                        <h2 className="text-2xl hover:cursor-pointer">Vores adresse</h2>
                                        <p className="text-gray-100">Sønderallé 30A 8800 Viborg</p>
                                    </div>
                                </div>

                                <div className="flex my-4 w-2/3 lg:w-1/2">
                                    <div className="flex flex-col">
                                        <i className="fas fa-phone-alt pt-2 pr-2"/>
                                    </div>
                                    <div className="flex flex-col">
                                        <h2 className="text-2xl">Ring til os</h2>
                                        <p className="text-gray-100">Tel: +45 23 90 56 02</p>
                                    </div>
                                </div>
                            </div>
                            <div className="swap-off">
                                <div className="lg:h-full">
                                    <iframe
                                        className="absolute w-full h-full"
                                        src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=30A%20Sønderallé%20,%20Viborg,%20Danmark+(My%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                                        allowFullScreen
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                        </label>
                    </div>
                </div>

                <input type="checkbox" id="googleMapsModal" className="modal-toggle"/>
                <div className="modal">
                    <div className="modal-box">
                        <div className="lg:w-1/2 w-full p-4">
                            <div className="relative aspect-w-16 h-[50vw] lg:h-full aspect-h-9">
                                <iframe
                                    className="absolute inset-0 w-full h-full"
                                    src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=30A%20Sønderallé%20,%20Viborg,%20Danmark+(My%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                                    allowFullScreen
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
